import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { saveMetadata } from './metadata.action';
import { formatLinkedTextToMetadata } from './navigation.prepare';

export const openTextOverflow = createAction('navigation/open_text_overflow');
export const closeTextOverflow = createAsyncThunk('navigation/close_text_overflow', async (payload, { dispatch, getState }) => {
  if (INKIVE.C.BOOK.initialized && INKIVE.C.SHOW_TEXT_OVERFLOW) {
    const state = getState();
    const linkedTexts = formatLinkedTextToMetadata(state.editor.linkedTextElements);
    const metadata = state.metadata.text_overflow?.chains;

    if (JSON.stringify(linkedTexts) !== JSON.stringify(metadata)) {
      const textOverflowMetadata = { text_overflow: { chains: linkedTexts } };

      dispatch(saveMetadata(textOverflowMetadata));

      INKIVE.Metadata.text_overflow = INKIVE.Metadata.text_overflow ?? {};
      INKIVE.Metadata.text_overflow.chains = metadata;
    }
  }

  return payload;
});

export const toggleLoadingTextOverflow = createAction('navigation/toggle_loading_text_overflow');
export const toggleLockedTextOverflow = createAction('navigation/toggle_locked_text_overflow');
